import React from "react";
import TableReservationActivities from "../../TableReservationActivities";

const ReservationActivitiesPage = () => {
  return (
    <div>
      <TableReservationActivities />
    </div>
  );
};

export default ReservationActivitiesPage;
